<template>
    <div class="apaympro-container">

        <!-- Loader -->
        <loading
            :active.sync="isLoading"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
        ></loading>

        <!-- Color Top Bar -->
        <div class="apaympro-color-bar"></div>

        <!-- Form Payment -->
        <div id="page-okay" class="apaympro-wrapper animated fadeIn mb-5 mt-5">
            <div id="payment-page-pay" class="apaympro-page">
                <div class="apaympro-header">
                    <div class="company-logo" v-if="dataPage.business_logo">
                        <img
                            id="company-logo-img"
                            :src="dataPage.business_logo"
                            alt="Business Logo"
                        />
                    </div>
                    <div class="page-info">
                        <h3 id="page-name" class="page-name">{{ dataPage.name_page }}</h3>
                        <p class="company-name">
                            PROPOSÉ PAR <span id="company-name" style="font-weight: 600;">{{ dataPage.business_name }}</span>
                        </p>
                    </div>
                    <div class="page-description">
                        <span id="page-description">{{ dataPage.description_page }}</span>
                    </div>
                </div>

                <div class="body">
                    <form
                        id="payment-form"
                        name="payment-form"
                        :class="hide == true ? 'payment-form' : 'payment-form hidden'"
                    >
                        <div class="element-pair">
                            <div class="element-pair-container">
                                <div class="element-wrap">
                                    <div class="element-label">
                                        <span>Nom</span>
                                    </div>
                                    <input
                                        v-model="dataFormulaire.nom"
                                        type="text"
                                        class="element-is-input"
                                        name="name"
                                    />
                                </div>
                                <div class="element-wrap">
                                    <div class="element-label">
                                        <span>Prénom(s)</span>
                                    </div>
                                    <input
                                        v-model="dataFormulaire.prenom"
                                        type="text"
                                        class="element-is-input"
                                        name="prenom"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="element-pair">
                            <div class="element-label">
                                <span>Numéro de téléphone</span>
                            </div>
                            <div class="element-pair-container">
                                <div
                                    class="element-wrap element-wrap-on-left"
                                >
                                    <multiselect
                                        v-model="indice"
                                        :options="options"
                                        :multiple="false"
                                        placeholder="Indicatif"
                                        tag-placeholder="Indicatif"
                                        track-by="code"
                                        label="country"
                                        :searchable="true"
                                    >
                                        <template slot="singleLabel" slot-scope="{ option }">{{ option.country_code }}</template>
                                        <span slot="noResult">Aucun résultat trouvé.</span>
                                    </multiselect>
                                </div>
                                <div class="element-wrap element-wrap-on-right"> 
                                    <input
                                        class="element-is-input"
                                        type="text"
                                        v-mask="'## ## ## ## ##'"
                                        v-model="dataFormulaire.telephone"
                                        name="telephone"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="element-wrap">
                            <div class="element-label">
                                <span>Adresse e-mail (Optionnel)</span>
                            </div>
                            <input
                                v-model="dataFormulaire.email"
                                type="email"
                                class="element-is-input"
                                name="email"
                            />
                        </div>

                        <div class="element-pair">
                            <div class="element-label">
                                <span>Montant à payer</span>
                            </div>
                            <div class="element-pair-container">
                                <div
                                    class="element-wrap element-wrap-for-select element-wrap-on-left"
                                >
                                    <select
                                        v-model="dataFormulaire.devise"
                                        class="element-is-select"
                                    >
                                        <option value="XOF" selected>XOF</option>
                                    </select>
                                </div>
                                <div class="element-wrap element-wrap-on-right">
                                    <input
                                        :disabled="dataPage.amount !== ''"
                                        v-model="dataFormulaire.montant"
                                        type="text"
                                        v-on:keypress="numbersOnly"
                                        class="element-is-input"
                                        name="montant"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="element-wrap">
                            <div class="element-label">
                                <span>Motif de paiement (Optionnel)</span>
                            </div>
                            <textarea
                                v-model="dataFormulaire.motif"
                                type="text"
                                class="element-is-input"
                                name="motif"
                            ></textarea>
                        </div>

                        <div class="element-wrap element-wrap-for-submit">
                            <button
                                type="button"
                                id="pay-btn"
                                @click="payer"
                                :class="!dataFormulaire.nom || !dataFormulaire.prenom || !dataFormulaire.telephone || !dataFormulaire.montant || dataFormulaire.montant < 10 ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                style
                                :disabled="!dataFormulaire.nom || !dataFormulaire.prenom || !dataFormulaire.telephone || !dataFormulaire.montant || dataFormulaire.montant < 10"
                            >Payer maintenant</button>
                        </div>
                    </form>

                    <!-- Bloc success payment -->
                    <div
                        id="payment-success"
                        :class="hide == true ? 'payment-success animated fadeIn text-center hidden' : 'payment-success animated fadeIn text-center'"
                    >
                        <img src="../assets/confirmico.gif" alt="Logo payment success" />
                        <h3>Votre paiement s'est effectué avec succès !</h3>
                        <h5 class="payment-success-message">
                            Vous avez payé <b>{{ dataFormulaire.montant }}</b> {{ dataFormulaire.devise }} à la page <span>{{ dataPage.name_page }}</span> - <span style="font-weight: 600;">{{ dataPage.business_name }}</span>
                        </h5>
                    </div>
                    <!-- Bloc success payment -->

                    <div class="element-wrap element-wrap-for-submit mt-5 mb-5">
                        <button
                            href="https://www.apaym.com"
                            target="_blank"
                            :class="hide == true ? 'btn btn-outline-danger hidden btn-block' : 'btn btn-outline-danger btn-block'"
                        >À propos de APaym</button>
                    </div>

                </div>

            </div>
        </div>

        <!-- Footer APaym Secured Badge -->
        <div id="apaympro-footer" class="apaympro-footer animated fadeIn mt-5 mb-5">
            <a target="_blank" href="#">
                <img alt="APaym Pro secured badge" src="../assets/Secured-by-pci-dss.png" />
            </a>
        </div>


        <!-- *********** -->
        <!-- *********** -->
        <!-- MODAL BLOC -->
        <!-- *********** -->
        <!-- *********** -->


        <!-- Begin Payement Section -->
        <b-modal
            class="modal-content"
            id="openPayment"
            ref="openPaymentModal"
            no-close-on-backdrop
            hide-footer
            hide-header
            style="padding: 0;"
            scrollable
        >
            <!-- Le Body | size="lg" -->
            <form>
                <!-- Large screen only -->
                <div
                    class="btn btn-link btn-floating btn-sm btn-close-modal display-for-large-only"
                    @click="closeModal('openPaymentModal')"
                >
                    <i class="fas fa-times"></i>
                </div>
                <div
                    style="
                        position: absolute;
                        color: #fff;
                        top: 100%;
                        cursor: pointer;
                        left: 35%;
                        padding-top: 15px;
                    "
                    @click="closeModal('openPaymentModal')"
                    class="display-for-large-only"
                >
                    <i class="fas fa-lock"></i> Sécurisé par
                    <strong>APaym</strong>
                </div>
                <!-- Large screen only -->

                <!-- Small screen only -->
                <div
                    class="btn-primary btn-floating btn-sm btn-close-modal-small display-for-small-only"
                    @click="closeModal('openPaymentModal')"
                    style="
                        background: #ff9f00;
                        border: none;
                    "
                >
                    <i class="fas fa-times"></i>
                </div>
                <div class="text-modal-small display-for-small-only">Payer <strong style="white-space: nowrap;">{{ dataPage.business_name }}</strong> par</div>
                <!-- Small screen only -->

                <!-- Large screen Only -->
                <b-tabs
                    card
                    vertical
                    style="
                        display: flex;
                        border-bottom: none;
                    "
                    class="nav line-tabs display-for-large-only"
                    v-model="tabIndex"
                >
                    <div
                        style="
                            display: flex;
                            flex-direction: row;
                            position: absolute;
                            z-index: 1;
                            align-items: center;
                            width: 100%;
                            padding: 10px;
                            justify-content: space-between;
                            border-bottom: 1px solid rgb(255, 159, 0);
                        "
                    >
                        <img src="../assets/Logo-APAYM-PRO.png" width="100" alt="Logo APaym Pro" style="position: relative; left: -44%;" />
                        <span style="font-size: 12px;" v-if="dataFormulaire.motif">{{ dataFormulaire.motif.trim() }}</span>
                        <div
                            style="
                                display:flex;
                                flex-direction: column;
                                top: 5px;
                                z-index: 1;
                                align-items: flex-end;
                                padding: 5px;
                            "
                        >
                            <span style="font-size: 12px;">{{ dataFormulaire.prenom.trim() }} {{ dataFormulaire.nom.trim() }}</span>
                            <span style="font-size: 12px;">{{ indice.code }} {{ dataFormulaire.telephone }}</span>
                            <span style="font-size: 15px; font-weight: 600">{{ dataFormulaire.montant }} {{ dataFormulaire.devise }}</span>
                        </div>
                    </div>

                    <b-tab title="Payer avec" disabled>
                        <template slot="title">
                            <h3
                                style="color: #000000; font-size: 14px; position: relative; top: -30px; line-height: 1.3em;"
                            >
                                Payer <br>
                                <strong style="white-space: nowrap;">{{ dataPage.business_name }}</strong>  <br>
                                par
                            </h3>
                        </template>
                    </b-tab>

                    <b-tab title="Visa QR" active>
                        <template slot="title">
                            <i class="la la-qrcode"></i>&nbsp;
                            <span style="margin-left: 3px">Visa QR</span>
                        </template>
                        <b-card-text>
                            <div class="container">
                                <loading
                                    :active.sync="isLoadingQr"
                                    :can-cancel="true"
                                    :on-cancel="onCancelQr"
                                    :is-full-page="fullPageQr"
                                ></loading>

                                <div class="checkout__stage">
                                    <section id="payment-form" class="payment-form" style="position: relative; top: 40px;">
                                        <div class="visa-qr-container" style="padding-top: 30px;">
                                            <div>
                                                <div class="visa-qr-container__header">
                                                    <div
                                                        style="
                                                            position: absolute;
                                                            top: -48px;
                                                            left: 0;
                                                        "
                                                    >
                                                        <img
                                                            src="../assets/img/visa-qr.png"
                                                            alt="Visa Logo"
                                                            width="110"
                                                        />
                                                    </div>
                                                    <p
                                                        class="instruction"
                                                        style=""
                                                    >Scannez le QR code ci-dessous dans votre application APaym, Ecobank, ou toute autre application Visa pour compléter le paiement.</p>
                                                </div>
                                                <div class="qr__wrapper">
                                                    <div class="qr__code">
                                                        <img
                                                            v-if="qrCodeUri"
                                                            name="qrCodeImage"
                                                            alt="APaym Pro QR Code"
                                                            :src="qrCodeUri"
                                                            id="qrCodeImage"
                                                            style="width: 70%;"
                                                        />
                                                    </div>
                                                </div>
                                                <div class="qr__wrapper mt-2 mb-5">
                                                    <div class="qr__code">
                                                        <i
                                                            class="fas fa-spinner fa-spin"
                                                            style="font-size: 20px;"
                                                            v-if="qrCodeUri"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </b-card-text>
                    </b-tab>

                    <b-tab title="Visa">
                        <template slot="title">
                            <i class="la la-university"></i>&nbsp;
                            <span style="margin-left: 3px">Carte Bancaire</span>
                        </template>
                        <b-card-text>
                            <div class="container">
                                <div class="checkout__stage">
                                    <section id="payment-form" class="payment-form" style="position: relative; top: 40px;">
                                        <div class="visa-qr-container" style="padding-top: 30px;">
                                            <div>
                                                <div class="visa-qr-container__header">
                                                    <div
                                                        style="
                                                            position: absolute;
                                                            top: -48px;
                                                            left: 0;
                                                        "
                                                    >
                                                        <img
                                                            src="../assets/img/visa-mastercard.png"
                                                            alt="Visa & Mastercard Logos"
                                                            width="150"
                                                        />
                                                    </div>
                                                    <p
                                                        class="instruction"
                                                        v-if="isOtherCard"
                                                    >
                                                        Renseignez les informations de votre carte (PAN, Date d'expiration et CVV) 
                                                        et validez afin de compléter le paiement.
                                                    </p>

                                                    <p class="instruction" v-if="!isBicici">
                                                        Choisissez votre carte de paiement.
                                                    </p>
                                                    <div class="" v-if="!cardChoice">
                                                        <i
                                                            class="fas fa-university text-primary mb-3"
                                                            style="font-size: 23px;"
                                                        ></i>
                                                        <p
                                                            class="instruction"
                                                        >Choisissez votre banque pour commencer le paiement.</p>
                                                    </div>
                                                </div>
                                                
                                                <div class="qr__wrapper mt-2 mb-5 container">

                                                    <div class="mt-4" v-if="!cardChoice">
                                                        <div class="form-group mb-3">
                                                            <button
                                                                class="btn btn-outline-light"
                                                                type="button"
                                                                style="width: 80%"
                                                                v-on:click="isBicici = !isBicici; cardChoice = !cardChoice"
                                                            >Cartes BICICI</button>
                                                        </div>
                                                        <div class="form-group mb-3">
                                                            <button
                                                                class="btn btn-outline-light"
                                                                type="button"
                                                                style="width: 80%"
                                                            >Autres banques</button>
                                                        </div>
                                                    </div>

                                                    <!-- Bank card is Bicici -->
                                                    <transition name="fade" v-if="!isBicici">
                                                        <div class="mt-3">
                                                            <div class="form-group mb-3">
                                                                <!-- <label class="mb-3">Votre carte est :</label> -->
                                                                <div style="display: flex;">
                                                                    <label
                                                                        class="payment__type radio radio-inline radio-primary"
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            name="bank_card_type"
                                                                            value="VISA"
                                                                            @change="selectCardType($event)"
                                                                            style="position: relative; opacity: 1;"
                                                                        />
                                                                        <!-- <span>
                                                                            <b>Visa</b>
                                                                        </span> -->
                                                                        <img src="../assets/img/visa-1.png" width="110" height="auto">
                                                                    </label>
                                                                    <label
                                                                        class="payment__type radio radio-inline radio-primary"
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            name="bank_card_type"
                                                                            value="MASTERCARD"
                                                                            @change="selectCardType($event)"
                                                                            style="position: relative; opacity: 1;"
                                                                        />
                                                                        <!-- <span>
                                                                            <b>Mastercard</b>
                                                                        </span> -->
                                                                        <img src="../assets/img/mastercard-1.png" width="110" height="auto">
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <!-- Valider la transaction Bicici -->
                                                            <div
                                                                class="element-wrap element-wrap-for-submit"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    :class=" !cardType ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                                    @click="sendBicici"
                                                                    :disabled="!cardType"
                                                                >Valider</button>
                                                            </div>
                                                            <!-- <div class="form-group mt-3">
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-github btn-link"
                                                                    v-on:click="isBicici = !isBicici; cardChoice = !cardChoice"
                                                                >Annuler</button>
                                                            </div> -->
                                                        </div>
                                                    </transition>
                                                    <!-- Bank card is Bicici -->

                                                    <!-- Show BICICI Form on Iframe -->
                                                    <div class="biciciForm" v-if="formBicici">
                                                        
                                                        <div class="btn btn-link btn-floating btn-sm btn-close-modal" style="background: #000000; left: 90%;">
                                                            <i v-on:click="formBicici = false; isBicici = false; cardType = '';" class="fas fa-times"></i>
                                                        </div>
                                                        <iframe
                                                            :src="contentBicici"
                                                            frameborder="0"
                                                            scrolling="yes"
                                                            style="height: 100%; width: 100%;"
                                                        ></iframe>
                                                    </div>
                                                    <!-- Show BICICI Form on Iframe -->

                                                    <!-- Bank card is not Bicici -->
                                                    <div v-if="isOtherCard">
                                                        <div class="element-wrap">
                                                            <input
                                                                type="text"
                                                                placeholder="Les 16 chiffres de votre carte"
                                                                class="element-is-input"
                                                                v-model="dataVisaCard.pan"
                                                                v-mask="'#### #### #### ####'"
                                                            />
                                                        </div>
                                                        <div class="element-pair">
                                                            <div class="element-pair-container">
                                                                <div
                                                                    class="element-wrap element-wrap-on-left"
                                                                >
                                                                    <input
                                                                        v-model="dataVisaCard.expiration"
                                                                        placeholder="MM/AA"
                                                                        class="element-is-input"
                                                                        v-mask="'##/##'"
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="element-wrap element-wrap-on-right"
                                                                >
                                                                    <input
                                                                        class="element-is-input"
                                                                        type="text"
                                                                        placeholder="CVV"
                                                                        v-mask="'###'"
                                                                        v-model="dataVisaCard.cvv"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="element-wrap element-wrap-for-submit">
                                                            <button
                                                                type="button"
                                                                id="pay-btn"
                                                                @click="sendVisa"
                                                                class="btn btn-dark btn-block"
                                                                style
                                                            >Valider</button>
                                                        </div>
                                                    </div>
                                                    <!-- Bank card is not Bicici -->

                                                    <div class="mt-3">
                                                        <loading
                                                            :active.sync="isLoadingBicici"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelBicici"
                                                            :is-full-page="fullPageBicici"
                                                        ></loading>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </b-card-text>
                    </b-tab>

                    <b-tab title="Orange money">
                        <template slot="title">
                            <i class="la la-mobile"></i>&nbsp;
                            <span style="margin-left: 3px">Orange Money</span>
                        </template>
                        <b-card-text>

                            <div class="container">
                                <div class="checkout__stage">
                                    <loading
                                        :active.sync="isLoadingOrange"
                                        :can-cancel="false"
                                        :on-cancel="onCancelOrange"
                                        :is-full-page="fullPageOrange"
                                    ></loading>
                                    <section id="payment-form" class="payment-form" style="position: relative; top: 40px;">
                                        <div class="visa-qr-container" style="padding-top: 30px;">
                                            <div>
                                                <div class="visa-qr-container__header">
                                                    <div
                                                        style="
                                                            position: absolute;
                                                            top: -48px;
                                                            left: 0;
                                                        "
                                                    >
                                                        <img
                                                            src="../assets/img/om-1.png"
                                                            alt="Orange money Logo"
                                                            width="150"
                                                        />
                                                    </div>
                                                    <p class="instruction">
                                                        Cliquez sur
                                                        <b>Valider</b> afin d'être redirigé sur la page de paiement d'Orange.
                                                    </p>
                                                </div>
                                                
                                                <div class="qr__wrapper mt-2 mb-5 container">

                                                    <div class="element-wrap element-wrap-for-submit">
                                                        <button
                                                            type="button"
                                                            id="pay-btn"
                                                            @click="sendOM"
                                                            class="btn btn-dark btn-block"
                                                            style
                                                        >Valider</button>

                                                        <div
                                                            v-if="orangeOkay"
                                                            class="displayerror__details mt-3"
                                                            style="padding: 10px 5px 2px 5px;"
                                                        >
                                                            <div>
                                                                <p
                                                                    class="paiement-failed"
                                                                    style="font-weight: 600;color: #261b64;"
                                                                >Paiement en attente de validation</p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="displayerror__details mt-3"
                                                            v-if="orangeNOkay"
                                                        >
                                                            <div>
                                                                <p class="paiement-failed">Paiement échoué</p>
                                                                <div
                                                                    class="error-information"
                                                                >Vous avez annulé la transaction, solde insuffisant, numéro incorrect, mot de passe incorrect, paiement réfusé pour délai dépassé, transaction incomplète ou erreur système.</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>

                        </b-card-text>
                    </b-tab>

                    <b-tab title="MTN money">
                        <template slot="title">
                            <i class="la la-mobile"></i>&nbsp;
                            <span style="margin-left: 3px">MTN Money</span>
                        </template>
                        <b-card-text>

                            <div class="container">
                                <div class="checkout__stage">
                                    <section id="payment-form" class="payment-form" style="position: relative; top: 40px;">
                                        <div class="visa-qr-container" style="padding-top: 30px;">
                                            <div>
                                                <div class="visa-qr-container__header">
                                                    <div
                                                        style="
                                                            position: absolute;
                                                            top: -48px;
                                                            left: 0;
                                                        "
                                                    >
                                                        <img
                                                            src="../assets/img/momo-1.png"
                                                            alt="MTN money Logo"
                                                            width="150"
                                                        />
                                                    </div>
                                                    <p class="instruction">
                                                        Renseignez votre numéro MoMo et validez. Ensuite, rendez-vous sur votre téléphone et suivez les instructions de MTN en composant le
                                                        <b>*133#</b> pour valider le paiement.
                                                    </p>
                                                </div>
                                                
                                                <div class="qr__wrapper mt-2 mb-5 container">

                                                    <div class="element-wrap">
                                                        <input
                                                            type="text"
                                                            placeholder="Votre numéro MoMo"
                                                            class="element-is-input"
                                                            v-model="dataMoMo.numero"
                                                            v-mask="'## ## ## ## ##'"
                                                        />
                                                    </div>

                                                    <div class="element-wrap element-wrap-for-submit">
                                                        <button
                                                            type="button"
                                                            id="pay-btn"
                                                            @click="sendMoMo"
                                                            :class="!dataMoMo.numero ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                            :disabled="!dataMoMo.numero"
                                                        >Valider</button>

                                                        <div
                                                            v-if="mtnOkay"
                                                            class="displayerror__details mt-3"
                                                            style="padding: 10px 5px 2px 5px;"
                                                        >
                                                            <div>
                                                                <p
                                                                    class="paiement-failed"
                                                                    style="font-weight: 600;color: #261b64;"
                                                                >Paiement en attente de validation</p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="displayerror__details mt-3"
                                                            v-if="mtnNOkay"
                                                        >
                                                            <div>
                                                                <p class="paiement-failed">Paiement échoué</p>
                                                                <div
                                                                    class="error-information"
                                                                >Solde insuffisant, numéro incorrect, mot de passe incorrect, transaction incomplète ou erreur système.</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mt-5">
                                                        <loading
                                                            :active.sync="isLoadingMomo"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelMomo"
                                                            :is-full-page="fullPageMomo"
                                                        ></loading>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>

                        </b-card-text>
                    </b-tab>

                    <b-tab title="Moov money">
                        <template slot="title">
                            <i class="la la-mobile"></i>&nbsp;
                            <span style="margin-left: 3px">Moov Money</span>
                        </template>
                        <b-card-text>

                            <div class="container">
                                <div class="checkout__stage">
                                    <section id="payment-form" class="payment-form" style="position: relative; top: 40px;">
                                        <div class="visa-qr-container" style="padding-top: 30px;">
                                            <div>
                                                <div class="visa-qr-container__header">
                                                    <div
                                                        style="
                                                            position: absolute;
                                                            top: -48px;
                                                            left: 0;
                                                        "
                                                    >
                                                        <img
                                                            src="../assets/img/moov-1.png"
                                                            alt="Moov money Logo"
                                                            width="150"
                                                        />
                                                    </div>
                                                    <p
                                                        class="instruction"
                                                    >Renseignez votre numéro Moov money et validez. Rendez-vous ensuite sur votre téléphone et veuillez suivre les instructions de Moov pour valider le paiement.</p>
                                                </div>
                                                
                                                <div class="qr__wrapper mt-2 mb-5 container">

                                                    <div class="element-wrap">
                                                        <input
                                                            type="text"
                                                            placeholder="Votre numéro Flooz"
                                                            class="element-is-input"
                                                            v-model="dataMoov.numero"
                                                            v-mask="'## ## ## ## ##'"
                                                        />
                                                    </div>

                                                    <div class="element-wrap element-wrap-for-submit">
                                                        <button
                                                            type="button"
                                                            id="pay-btn"
                                                            @click="sendMoov"
                                                            :class="!dataMoov.numero ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                            :disabled="!dataMoov.numero"
                                                        >Valider</button>

                                                        <div
                                                            v-if="moovOkay"
                                                            class="displayerror__details mt-3"
                                                            style="padding: 10px 5px 2px 5px;"
                                                        >
                                                            <div>
                                                                <p
                                                                    class="paiement-failed"
                                                                    style="font-weight: 600;color: #261b64;"
                                                                >Paiement en attente de validation</p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="displayerror__details mt-3"
                                                            v-if="moovNOkay"
                                                        >
                                                            <div>
                                                                <p class="paiement-failed">Paiement échoué</p>
                                                                <div
                                                                    class="error-information"
                                                                >Solde insuffisant, transaction introuvable, transaction interrompue, session échue ou erreur système.</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="mt-5">
                                                        <loading
                                                            :active.sync="isLoadingFlooz"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelFlooz"
                                                            :is-full-page="fullPageFlooz"
                                                        ></loading>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>

                        </b-card-text>
                    </b-tab>

                    <b-tab title="APaym USSD">
                        <template slot="title">
                            <i class="la la-slack"></i>&nbsp;
                            <span style="margin-left: 3px;">USSD APaym</span>
                        </template>
                        <b-card-text>
                            <div class="container">
                                <div class="checkout__stage">
                                    <section id="payment-form" class="payment-form" style="position: relative; top: 40px;">
                                        <div class="visa-qr-container" style="padding-top: 30px;">
                                            <div>
                                                <div class="visa-qr-container__header">
                                                    <div
                                                        style="
                                                            position: absolute;
                                                            top: -48px;
                                                            left: 0;
                                                        "
                                                    >
                                                        <img
                                                            src="../assets/img/apaym-1.png"
                                                            alt="APaym Logo"
                                                            width="110"
                                                        />
                                                    </div>
                                                    <p class="instruction">
                                                        Pour obtenir votre code de paiement, composez le
                                                        <b>*766#</b> sur Orange et MTN.
                                                    </p>

                                                </div>
                                                
                                                <div class="qr__wrapper mt-2 mb-5">

                                                    <div class="element-pair mt-3">
                                                        <div class="element-pair-container mt-4">
                                                            <div
                                                                class="element-wrap element-wrap-for-select element-wrap-on-left"
                                                            >
                                                                <select
                                                                    v-model="dataApaymPay.indice"
                                                                    class="element-is-select"
                                                                >
                                                                    <option
                                                                        :selected="dataApaymPay.indice == flag.dial_code"
                                                                        v-for="flag in json"
                                                                        :key="flag.code"
                                                                        :value="flag.dial_code"
                                                                    >{{ flag.flag }} + {{ flag.dial_code }}</option>
                                                                </select>
                                                            </div>
                                                            <div class="element-wrap element-wrap-on-right">
                                                                <input
                                                                    class="element-is-input"
                                                                    type="text"
                                                                    v-mask="'## ## ## ## ##'"
                                                                    v-model="dataApaymPay.numApaym"
                                                                    placeholder="Numéro de tél. APaym"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="element-wrap">
                                                        <input
                                                            type="text"
                                                            class="element-is-input"
                                                            :disabled="!dataApaymPay.numApaym"
                                                            v-model="dataApaymPay.codeApaym"
                                                            placeholder="Code de paiement"
                                                        />
                                                    </div>

                                                    <div class="element-wrap element-wrap-for-submit">
                                                        <button
                                                            type="button"
                                                            id="pay-btn"
                                                            @click="sendAPaym"
                                                            :class="!dataApaymPay.numApaym || !dataApaymPay.codeApaym ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                            :disabled="!dataApaymPay.numApaym || !dataApaymPay.codeApaym"
                                                        >Valider</button>
                                                    </div>

                                                    <div class="mt-3">
                                                        <loading
                                                            :active.sync="isLoadingAPaym"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelAPaym"
                                                            :is-full-page="fullPageAPaym"
                                                        ></loading>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </b-card-text>
                    </b-tab>

                    <b-tab title="APaym">
                        <template slot="title">
                            <!-- <i class="la la-mobile"></i>&nbsp; -->
                            <img 
                                src="../assets/apaym.png" 
                                style="
                                    width: 11px;
                                "
                            >
                            <span style="margin-left: 8px">APaym</span>
                        </template>
                        <b-card-text>
                            <div class="container">
                                <!-- Content Paiment APaym - Listing des cartes visa du profil APaym -->
                                <div class="checkout__stage">
                                    <section id="payment-form" class="payment-form" style="position: relative; top: 40px;">
                                        <div class="visa-qr-container" style="padding-top: 30px;">
                                            <div>
                                                <div class="visa-qr-container__header">
                                                    <div 
                                                        class="btn btn-link" 
                                                        style="
                                                            display: flex;
                                                            align-items: center;
                                                            background: none;
                                                            text-align: center;
                                                            justify-content: center;
                                                        "
                                                        v-if="showCard == true"
                                                        @click="disconnectApaym"
                                                    >
                                                        Déconnexion
                                                    </div>

                                                    <div
                                                        style="
                                                            position: absolute;
                                                            top: -48px;
                                                            left: 0;
                                                        "
                                                    >
                                                        <img
                                                            src="../assets/img/apaym-1.png"
                                                            alt="APaym Logo"
                                                            width="110"
                                                        />
                                                    </div>
                                                    <p class="instruction" v-if="loginApaym">Connectez-vous à votre compte APaym pour afficher vos cartes Visa.</p>

                                                </div>
                                                
                                                <div class="qr__wrapper mt-2 mb-5">
                                                    <div class="element-pair mt-3" v-if="loginApaym">
                                                        <div class="element-pair-container mt-4">
                                                            <div
                                                                class="element-wrap element-wrap-for-select element-wrap-on-left"
                                                            >
                                                                <select
                                                                    v-model="dataApaymPayAuth.indice"
                                                                    class="element-is-select"
                                                                >
                                                                    <option
                                                                        :selected="indice == flag.dial_code"
                                                                        v-for="flag in json"
                                                                        :key="flag.code"
                                                                        :value="flag.dial_code"
                                                                    >{{ flag.flag }} + {{ flag.dial_code }}</option>
                                                                </select>
                                                            </div>
                                                            <div class="element-wrap element-wrap-on-right">
                                                                <div
                                                                    style="
                                                                        display: flex;
                                                                        flex-direction: row;
                                                                        align-items: center;
                                                                    "
                                                                >
                                                                    <input
                                                                        class="element-is-input"
                                                                        type="text"
                                                                        v-mask="'## ## ## ## ##'"
                                                                        v-model="dataApaymPayAuth.numApaym"
                                                                        placeholder="Numéro de tél. APaym"
                                                                    />
                                                                    <i
                                                                        class="fas fa-search searchIcon"
                                                                        aria-hidden="true"
                                                                        @click="sendAPaymAuth"
                                                                    ></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="element-wrap" v-if="hideCodePay">
                                                        <label class="instruction">Renseigner le code de connexion ici.</label>
                                                        <input
                                                            type="text"
                                                            class="element-is-input"
                                                            :disabled="!dataApaymPayAuth.numApaym"
                                                            v-model="dataApaymPayAuth.codeApaym"
                                                            placeholder="Code de connexion"
                                                        />
                                                    </div>

                                                    <div
                                                        class="element-wrap element-wrap-for-submit"
                                                        v-if="hideCodePay"
                                                    >
                                                        <button
                                                            type="button"
                                                            id="pay-btn"
                                                            @click="sendAPaymToken"
                                                            :class="!dataApaymPayAuth.numApaym || !dataApaymPayAuth.codeApaym ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                            :disabled="!dataApaymPayAuth.numApaym || !dataApaymPayAuth.codeApaym"
                                                        >Connectez-vous</button>
                                                    </div>

                                                    <!-- Liste des cartes -->
                                                    <div v-if="showCard == true">
                                                        <ul
                                                            class="list-unstyled text-left"
                                                            :style="cardsLength > 5 ? 'height: 250px; overflow-y: scroll;' : 'height: auto;'"
                                                        >
                                                            <li
                                                                class="media py-3"
                                                                v-for="(carte,i) in cards"
                                                                :key="i"
                                                                style="cursor: pointer;"
                                                                @click="payWithApaym(carte)"
                                                            >
                                                                <div class="mr-3 position-relative">
                                                                    <img
                                                                        class
                                                                        :src="require(`../assets/img/cards/${carte.imgCard}`)"
                                                                        alt="image"
                                                                        width="45"
                                                                    />
                                                                    <!-- <span
                                                                        :class="carte.statut_card == 1 ? 'badge-point badge-success avatar-badge' : 'badge-point badge-danger avatar-badge'"
                                                                        v-b-tooltip
                                                                        :title="carte.statut_card == 1 ? 'Carte active' : 'Carte inactive'"
                                                                    ></span> -->
                                                                </div>
                                                                <div class="media-body">
                                                                    <div
                                                                        class="d-flex justify-content-between"
                                                                        style="text-align: left;"
                                                                    >
                                                                        <div>
                                                                            {{ carte.nickname }}
                                                                            <br />
                                                                            <span class="font-11">
                                                                                Visa **** {{ carte.last_4_digit }}
                                                                                <img
                                                                                    src="../assets/img/icons/icon-recieve_money-193.png"
                                                                                    alt
                                                                                    width="15"
                                                                                    class="ml-2"
                                                                                    v-b-tooltip
                                                                                    title="Carte favorite"
                                                                                    :hidden="carte.favori_card == false"
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                        <div>Cliquez sur l'une de vos cartes pour effectuer le paiement</div>
                                                    </div>
                                                    <!-- Liste des cartes -->

                                                    <div class="mt-3">
                                                        <loading
                                                            :active.sync="isLoadingAPaymAuth"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelAPaymAuth"
                                                            :is-full-page="fullPageAPaymAuth"
                                                        ></loading>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </b-card-text>
                    </b-tab>

                </b-tabs>
                <!-- Large screen Only -->

                <!-- Small screen Only -->
                <b-tabs card style class="nav display-for-small-only" v-model="tabIndex">

                    <div
                        style="
                            display: flex;
                            flex-direction: row;
                            position: absolute;
                            z-index: 1;
                            align-items: center;
                            width: 100%;
                            padding: 10px;
                            justify-content: space-between;
                            border-bottom: 1px solid rgb(255, 159, 0);
                            background: rgb(0 0 0 / 8%);
                        "
                    >
                        <img src="../assets/Logo-APAYM-PRO.png" width="100" alt="Logo APaym Pro" />
                        <div
                            style="
                                display:flex;
                                flex-direction: column;
                                top: 5px;
                                z-index: 1;
                                align-items: flex-end;
                                padding: 5px;
                            "
                        >
                            <span
                                style="font-size: 13px;"
                            >{{ dataFormulaire.prenom }} {{ dataFormulaire.nom }}</span>
                            <span style="font-size: 12px;">{{ indice.code }} {{ dataFormulaire.telephone }}</span>
                            <span
                                style="font-size: 15px; font-weight: 600"
                            >{{ dataFormulaire.montant }} {{ dataFormulaire.devise }}</span>
                        </div>
                    </div>

                    <b-tab title="Payer avec" disabled>
                        <template slot="title">
                            <h3 style="display: none; position: relative;">Payer {{ dataPage.business_name }} par</h3>
                        </template>
                    </b-tab>

                    <b-tab title="Visa QR" active>
                        <template slot="title">
                            <i class="la la-qrcode"></i>&nbsp;
                            <span style="margin-left: 3px">Visa QR</span>
                        </template>
                        <b-card-text>
                            <div class="container">
                                <loading
                                    :active.sync="isLoadingQr"
                                    :can-cancel="true"
                                    :on-cancel="onCancelQr"
                                    :is-full-page="fullPageQr"
                                ></loading>

                                <div class="checkout__stage">
                                    <section id="payment-form" class="payment-form" style="position: relative; top: 40px;">
                                        <div class="visa-qr-container" style="padding-top: 30px;">
                                            <div>
                                                <div class="visa-qr-container__header">
                                                    <div>
                                                        <img
                                                            src="../assets/img/visa-qr.png"
                                                            alt="Visa Logo"
                                                            width="110"
                                                        />
                                                    </div>
                                                    <p
                                                        class="instruction mt-3"
                                                        style=""
                                                    >Scannez le QR code ci-dessous dans votre application APaym, Ecobank, ou toute autre application Visa pour compléter le paiement.</p>
                                                </div>
                                                <div class="qr__wrapper">
                                                    <div class="qr__code">
                                                        <img
                                                            v-if="qrCodeUri"
                                                            name="qrCodeImage"
                                                            alt="APaym Pro QR Code"
                                                            :src="qrCodeUri"
                                                            id="qrCodeImage"
                                                            style="width: 70%;"
                                                        />
                                                    </div>
                                                </div>
                                                <div class="qr__wrapper mt-2 mb-5">
                                                    <div class="qr__code">
                                                        <i
                                                            class="fas fa-spinner fa-spin"
                                                            style="font-size: 20px;"
                                                            v-if="qrCodeUri"
                                                        ></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </b-card-text>
                    </b-tab>

                    <b-tab title="Visa">
                        <template slot="title">
                            <i class="la la-university"></i>&nbsp;
                            <span style="margin-left: 3px">Carte Bancaire</span>
                        </template>
                        <b-card-text>
                            <div class="container">
                                <div class="checkout__stage">
                                    <section id="payment-form" class="payment-form" style="position: relative; top: 40px;">
                                        <div class="visa-qr-container" style="padding-top: 30px;">
                                            <div style="text-align: center;">
                                                <div class="visa-qr-container__header">
                                                    <div>
                                                        <img
                                                            src="../assets/img/visa-mastercard.png"
                                                            alt="Visa & Mastercard Logos"
                                                            width="150"
                                                        />
                                                    </div>
                                                    <p
                                                        class="instruction"
                                                        v-if="isOtherCard"
                                                    >
                                                        Renseignez les informations de votre carte (PAN, Date d'expiration et CVV) 
                                                        et validez afin de compléter le paiement.
                                                    </p>

                                                    <p class="instruction" v-if="!isBicici">
                                                        Choisissez votre carte de paiement.
                                                    </p>
                                                    <div class="" v-if="!cardChoice">
                                                        <i
                                                            class="fas fa-university text-primary mb-3"
                                                            style="font-size: 23px;"
                                                        ></i>
                                                        <p
                                                            class="instruction"
                                                        >Choisissez votre banque pour commencer le paiement.</p>
                                                    </div>
                                                </div>
                                                
                                                <div class="qr__wrapper mt-2 mb-5">

                                                    <div class="mt-4" v-if="!cardChoice">
                                                        <div class="form-group mb-3">
                                                            <button
                                                                class="btn btn-outline-light"
                                                                type="button"
                                                                style="width: 80%"
                                                                v-on:click="isBicici = !isBicici; cardChoice = !cardChoice"
                                                            >Cartes BICICI</button>
                                                        </div>
                                                        <div class="form-group mb-3">
                                                            <button
                                                                class="btn btn-outline-light"
                                                                type="button"
                                                                style="width: 80%"
                                                            >Autres banques</button>
                                                        </div>
                                                    </div>

                                                    <!-- Bank card is Bicici -->
                                                    <transition name="fade" v-if="!isBicici">
                                                        <div class="mt-3 container">
                                                            <div class="form-group mb-3">
                                                                <!-- <label class="mb-3">Votre carte est :</label> -->
                                                                <div style="display: flex;">
                                                                    <label
                                                                        class="payment__type radio radio-inline radio-primary"
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            name="bank_card_type"
                                                                            value="VISA"
                                                                            @change="selectCardType($event)"
                                                                            style="position: relative; opacity: 1;"
                                                                        />
                                                                        <img src="../assets/img/visa-1.png" width="110" height="auto">
                                                                    </label>
                                                                    <label
                                                                        class="payment__type radio radio-inline radio-primary"
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            name="bank_card_type"
                                                                            value="MASTERCARD"
                                                                            @change="selectCardType($event)"
                                                                            style="position: relative; opacity: 1;"
                                                                        />
                                                                        <img src="../assets/img/mastercard-1.png" width="110" height="auto">
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <!-- Valider la transaction Bicici -->
                                                            <div
                                                                class="element-wrap element-wrap-for-submit"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    :class=" !cardType ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                                    @click="sendBicici"
                                                                    :disabled="!cardType"
                                                                >Valider</button>
                                                            </div>
                                                            <!-- <div class="form-group mt-3">
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-github btn-link"
                                                                    v-on:click="isBicici = !isBicici; cardChoice = !cardChoice"
                                                                >Annuler</button>
                                                            </div> -->
                                                        </div>
                                                    </transition>
                                                    <!-- Bank card is Bicici -->

                                                    <!-- Show BICICI Form on Iframe -->
                                                    <div class="biciciForm" v-if="formBicici">
                                                        
                                                        <div class="btn btn-link btn-floating btn-sm btn-close-modal" style="background: #000000; left: 90%;">
                                                            <i v-on:click="formBicici = false; isBicici = false; cardType = '';" class="fas fa-times"></i>
                                                        </div>
                                                        <iframe
                                                            :src="contentBicici"
                                                            frameborder="0"
                                                            scrolling="yes"
                                                            style="height: 100%; width: 100%;"
                                                        ></iframe>
                                                    </div>
                                                    <!-- Show BICICI Form on Iframe -->

                                                    <!-- Bank card is not Bicici -->
                                                    <div v-if="isOtherCard">
                                                        <div class="element-wrap">
                                                            <input
                                                                type="text"
                                                                placeholder="Les 16 chiffres de votre carte"
                                                                class="element-is-input"
                                                                v-model="dataVisaCard.pan"
                                                                v-mask="'#### #### #### ####'"
                                                            />
                                                        </div>
                                                        <div class="element-pair">
                                                            <div class="element-pair-container">
                                                                <div
                                                                    class="element-wrap element-wrap-on-left"
                                                                >
                                                                    <input
                                                                        v-model="dataVisaCard.expiration"
                                                                        placeholder="MM/AA"
                                                                        class="element-is-input"
                                                                        v-mask="'##/##'"
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="element-wrap element-wrap-on-right"
                                                                >
                                                                    <input
                                                                        class="element-is-input"
                                                                        type="text"
                                                                        placeholder="CVV"
                                                                        v-mask="'###'"
                                                                        v-model="dataVisaCard.cvv"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="element-wrap element-wrap-for-submit">
                                                            <button
                                                                type="button"
                                                                id="pay-btn"
                                                                @click="sendVisa"
                                                                class="btn btn-dark btn-block"
                                                                style
                                                            >Valider</button>
                                                        </div>
                                                    </div>
                                                    <!-- Bank card is not Bicici -->

                                                    <div class="mt-3">
                                                        <loading
                                                            :active.sync="isLoadingBicici"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelBicici"
                                                            :is-full-page="fullPageBicici"
                                                        ></loading>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </b-card-text>
                    </b-tab>

                    <b-tab title="Orange money">
                        <template slot="title">
                            <i class="la la-mobile"></i>&nbsp;
                            <span style="margin-left: 3px">Orange Money</span>
                        </template>
                        <b-card-text>

                            <div class="container">
                                <div class="checkout__stage">
                                    <loading
                                        :active.sync="isLoadingOrange"
                                        :can-cancel="false"
                                        :on-cancel="onCancelOrange"
                                        :is-full-page="fullPageOrange"
                                    ></loading>
                                    <section id="payment-form" class="payment-form" style="position: relative; top: 40px;">
                                        <div class="visa-qr-container" style="padding-top: 30px;">
                                            <div>
                                                <div class="visa-qr-container__header">
                                                    <div>
                                                        <img
                                                            src="../assets/img/om-1.png"
                                                            alt="Orange money Logo"
                                                            width="150"
                                                        />
                                                    </div>
                                                    <p class="instruction">
                                                        Cliquez sur
                                                        <b>Valider</b> afin d'être redirigé sur la page de paiement d'Orange.
                                                    </p>
                                                </div>
                                                
                                                <div class="qr__wrapper mt-2 mb-5 container">

                                                    <div class="element-wrap element-wrap-for-submit">
                                                        <button
                                                            type="button"
                                                            id="pay-btn"
                                                            @click="sendOM"
                                                            class="btn btn-dark btn-block"
                                                            style
                                                        >Valider</button>

                                                        <div
                                                            v-if="orangeOkay"
                                                            class="displayerror__details mt-3"
                                                            style="padding: 10px 5px 2px 5px;"
                                                        >
                                                            <div>
                                                                <p
                                                                    class="paiement-failed"
                                                                    style="font-weight: 600;color: #261b64;"
                                                                >Paiement en attente de validation</p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="displayerror__details mt-3"
                                                            v-if="orangeNOkay"
                                                        >
                                                            <div>
                                                                <p class="paiement-failed">Paiement échoué</p>
                                                                <div
                                                                    class="error-information"
                                                                >Vous avez annulé la transaction, solde insuffisant, numéro incorrect, mot de passe incorrect, paiement réfusé pour délai dépassé, transaction incomplète ou erreur système.</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>

                        </b-card-text>
                    </b-tab>

                    <b-tab title="MTN money">
                        <template slot="title">
                            <i class="la la-mobile"></i>&nbsp;
                            <span style="margin-left: 3px">MTN Money</span>
                        </template>
                        <b-card-text>

                            <div class="container">
                                <div class="checkout__stage">
                                    <section id="payment-form" class="payment-form" style="position: relative; top: 40px;">
                                        <div class="visa-qr-container" style="padding-top: 30px;">
                                            <div>
                                                <div class="visa-qr-container__header">
                                                    <div>
                                                        <img
                                                            src="../assets/img/momo-1.png"
                                                            alt="MTN money Logo"
                                                            width="150"
                                                        />
                                                    </div>
                                                    <p class="instruction">
                                                        Renseignez votre numéro MoMo et validez. Ensuite, rendez-vous sur votre téléphone et suivez les instructions de MTN en composant le
                                                        <b>*133#</b> pour valider le paiement.
                                                    </p>
                                                </div>
                                                
                                                <div class="qr__wrapper mt-2 mb-5 container">

                                                    <div class="element-wrap">
                                                        <input
                                                            type="text"
                                                            placeholder="Votre numéro MoMo"
                                                            class="element-is-input"
                                                            v-model="dataMoMo.numero"
                                                            v-mask="'## ## ## ## ##'"
                                                        />
                                                    </div>

                                                    <div class="element-wrap element-wrap-for-submit">
                                                        <button
                                                            type="button"
                                                            id="pay-btn"
                                                            @click="sendMoMo"
                                                            :class="!dataMoMo.numero ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                            :disabled="!dataMoMo.numero"
                                                        >Valider</button>

                                                        <div
                                                            v-if="mtnOkay"
                                                            class="displayerror__details mt-3"
                                                            style="padding: 10px 5px 2px 5px;"
                                                        >
                                                            <div>
                                                                <p
                                                                    class="paiement-failed"
                                                                    style="font-weight: 600;color: #261b64;"
                                                                >Paiement en attente de validation</p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="displayerror__details mt-3"
                                                            v-if="mtnNOkay"
                                                        >
                                                            <div>
                                                                <p class="paiement-failed">Paiement échoué</p>
                                                                <div
                                                                    class="error-information"
                                                                >Solde insuffisant, numéro incorrect, mot de passe incorrect, transaction incomplète ou erreur système.</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mt-5">
                                                        <loading
                                                            :active.sync="isLoadingMomo"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelMomo"
                                                            :is-full-page="fullPageMomo"
                                                        ></loading>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>

                        </b-card-text>
                    </b-tab>

                    <b-tab title="Moov money">
                        <template slot="title">
                            <i class="la la-mobile"></i>&nbsp;
                            <span style="margin-left: 3px">Moov Money</span>
                        </template>
                        <b-card-text>

                            <div class="container">
                                <div class="checkout__stage">
                                    <section id="payment-form" class="payment-form" style="position: relative; top: 40px;">
                                        <div class="visa-qr-container" style="padding-top: 30px;">
                                            <div>
                                                <div class="visa-qr-container__header">
                                                    <div>
                                                        <img
                                                            src="../assets/img/moov-1.png"
                                                            alt="Moov money Logo"
                                                            width="150"
                                                        />
                                                    </div>
                                                    <p
                                                        class="instruction"
                                                    >Renseignez votre numéro Moov money et validez. Rendez-vous ensuite sur votre téléphone et veuillez suivre les instructions de Moov pour valider le paiement.</p>
                                                </div>
                                                
                                                <div class="qr__wrapper mt-2 mb-5 container">

                                                    <div class="element-wrap">
                                                        <input
                                                            type="text"
                                                            placeholder="Votre numéro Flooz"
                                                            class="element-is-input"
                                                            v-model="dataMoov.numero"
                                                            v-mask="'## ## ## ## ##'"
                                                        />
                                                    </div>

                                                    <div class="element-wrap element-wrap-for-submit">
                                                        <button
                                                            type="button"
                                                            id="pay-btn"
                                                            @click="sendMoov"
                                                            :class="!dataMoov.numero ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                            :disabled="!dataMoov.numero"
                                                        >Valider</button>

                                                        <div
                                                            v-if="moovOkay"
                                                            class="displayerror__details mt-3"
                                                            style="padding: 10px 5px 2px 5px;"
                                                        >
                                                            <div>
                                                                <p
                                                                    class="paiement-failed"
                                                                    style="font-weight: 600;color: #261b64;"
                                                                >Paiement en attente de validation</p>
                                                            </div>
                                                        </div>

                                                        <div
                                                            class="displayerror__details mt-3"
                                                            v-if="moovNOkay"
                                                        >
                                                            <div>
                                                                <p class="paiement-failed">Paiement échoué</p>
                                                                <div
                                                                    class="error-information"
                                                                >Solde insuffisant, transaction introuvable, transaction interrompue, session échue ou erreur système.</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="mt-5">
                                                        <loading
                                                            :active.sync="isLoadingFlooz"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelFlooz"
                                                            :is-full-page="fullPageFlooz"
                                                        ></loading>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>

                        </b-card-text>
                    </b-tab>

                    <b-tab title="APaym USSD">
                        <template slot="title">
                            <!-- <i class="la la-asterisk"></i>&nbsp;
                            <span style="margin-left: 3px">USSD APaym</span> -->
                            <!-- <i class="la la-asterisk" style="margin-left: -10px;"></i>&nbsp;# -->
                            <i class="la la-slack"></i>&nbsp;
                            <span style="margin-left: 3px;">USSD APaym</span>
                        </template>
                        <b-card-text>
                            <div class="container">
                                <div class="checkout__stage">
                                    <section id="payment-form" class="payment-form" style="position: relative; top: 40px;">
                                        <div class="visa-qr-container" style="padding-top: 30px;">
                                            <div>
                                                <div class="visa-qr-container__header">
                                                    <div>
                                                        <img
                                                            src="../assets/img/apaym-1.png"
                                                            alt="APaym Logo"
                                                            width="110"
                                                        />
                                                    </div>
                                                    <p class="instruction">
                                                        Pour obtenir votre code de paiement, composez le
                                                        <b>*766#</b> sur Orange et MTN.
                                                    </p>
                                                    <!-- <div class="instruction">
                                                        Il est aussi disponible dans l'app
                                                        <b>APaym</b> en sélectionnant l'une de vos cartes et en cliquant sur code de paiement.
                                                    </div> -->

                                                </div>
                                                
                                                <div class="qr__wrapper mt-2 mb-5">

                                                    <div class="element-pair mt-3">
                                                        <div class="element-pair-container mt-4">
                                                            <div
                                                                class="element-wrap element-wrap-for-select element-wrap-on-left"
                                                            >
                                                                <select
                                                                    v-model="dataApaymPay.indice"
                                                                    class="element-is-select"
                                                                >
                                                                    <option
                                                                        :selected="dataApaymPay.indice == flag.dial_code"
                                                                        v-for="flag in json"
                                                                        :key="flag.code"
                                                                        :value="flag.dial_code"
                                                                    >{{ flag.flag }} + {{ flag.dial_code }}</option>
                                                                </select>
                                                            </div>
                                                            <div class="element-wrap element-wrap-on-right">
                                                                <input
                                                                    class="element-is-input"
                                                                    type="text"
                                                                    v-mask="'## ## ## ## ##'"
                                                                    v-model="dataApaymPay.numApaym"
                                                                    placeholder="Numéro de tél. APaym"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="element-wrap">
                                                        <input
                                                            type="text"
                                                            class="element-is-input"
                                                            :disabled="!dataApaymPay.numApaym"
                                                            v-model="dataApaymPay.codeApaym"
                                                            placeholder="Code de paiement"
                                                        />
                                                    </div>

                                                    <div class="element-wrap element-wrap-for-submit">
                                                        <button
                                                            type="button"
                                                            id="pay-btn"
                                                            @click="sendAPaym"
                                                            :class="!dataApaymPay.numApaym || !dataApaymPay.codeApaym ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                            :disabled="!dataApaymPay.numApaym || !dataApaymPay.codeApaym"
                                                        >Valider</button>
                                                    </div>

                                                    <div class="mt-3">
                                                        <loading
                                                            :active.sync="isLoadingAPaym"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelAPaym"
                                                            :is-full-page="fullPageAPaym"
                                                        ></loading>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </b-card-text>
                    </b-tab>

                    <b-tab title="APaym">
                        <template slot="title">
                            <!-- <i class="la la-mobile"></i>&nbsp; -->
                            <img 
                                src="../assets/apaym.png" 
                                style="
                                    width: 13px;
                                "
                            >
                            <span style="margin-left: 4px">APaym</span>
                        </template>
                        <b-card-text>
                            <div class="container">
                                <!-- Content Paiment APaym - Listing des cartes visa du profil APaym -->
                                <div class="checkout__stage">
                                    <section id="payment-form" class="payment-form" style="position: relative; top: 40px;">
                                        <div class="visa-qr-container" style="padding-top: 30px;">
                                            <div>
                                                <div class="visa-qr-container__header">
                                                    <div 
                                                        class="btn btn-link" 
                                                        style="
                                                            display: flex;
                                                            align-items: center;
                                                            background: none;
                                                            text-align: center;
                                                            justify-content: center;
                                                        "
                                                        v-if="showCard == true"
                                                        @click="disconnectApaym"
                                                    >
                                                        Déconnexion
                                                    </div>

                                                    <div>
                                                        <img
                                                            src="../assets/img/apaym-1.png"
                                                            alt="APaym Logo"
                                                            width="110"
                                                        />
                                                    </div>
                                                    <p class="instruction" v-if="loginApaym">Connectez-vous à votre compte APaym pour afficher vos cartes Visa.</p>

                                                </div>
                                                
                                                <div class="qr__wrapper mt-2 mb-5">
                                                    <div class="element-pair mt-3" v-if="loginApaym">
                                                        <div class="element-pair-container mt-4">
                                                            <div
                                                                class="element-wrap element-wrap-for-select element-wrap-on-left"
                                                            >
                                                                <select
                                                                    v-model="dataApaymPayAuth.indice"
                                                                    class="element-is-select"
                                                                >
                                                                    <option
                                                                        :selected="indice == flag.dial_code"
                                                                        v-for="flag in json"
                                                                        :key="flag.code"
                                                                        :value="flag.dial_code"
                                                                    >{{ flag.flag }} + {{ flag.dial_code }}</option>
                                                                </select>
                                                            </div>
                                                            <div class="element-wrap element-wrap-on-right">
                                                                <div
                                                                    style="
                                                                        display: flex;
                                                                        flex-direction: row;
                                                                        align-items: center;
                                                                    "
                                                                >
                                                                    <input
                                                                        class="element-is-input"
                                                                        type="text"
                                                                        v-mask="'## ## ## ## ##'"
                                                                        v-model="dataApaymPayAuth.numApaym"
                                                                        placeholder="Numéro de tél. APaym"
                                                                    />
                                                                    <i
                                                                        class="fas fa-search searchIcon"
                                                                        aria-hidden="true"
                                                                        @click="sendAPaymAuth"
                                                                    ></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="element-wrap" v-if="hideCodePay">
                                                        <label class="instruction">Renseigner le code de connexion ici.</label>
                                                        <input
                                                            type="text"
                                                            class="element-is-input"
                                                            :disabled="!dataApaymPayAuth.numApaym"
                                                            v-model="dataApaymPayAuth.codeApaym"
                                                            placeholder="Code de connexion"
                                                        />
                                                    </div>

                                                    <div
                                                        class="element-wrap element-wrap-for-submit"
                                                        v-if="hideCodePay"
                                                    >
                                                        <button
                                                            type="button"
                                                            id="pay-btn"
                                                            @click="sendAPaymToken"
                                                            :class="!dataApaymPayAuth.numApaym || !dataApaymPayAuth.codeApaym ? 'btn btn-dark btn-disabled-custom btn-block' : 'btn btn-dark btn-block'"
                                                            :disabled="!dataApaymPayAuth.numApaym || !dataApaymPayAuth.codeApaym"
                                                        >Connectez-vous</button>
                                                    </div>

                                                    <!-- Liste des cartes -->
                                                    <div v-if="showCard == true">
                                                        <ul
                                                            class="list-unstyled text-left"
                                                            :style="cardsLength > 5 ? 'height: 250px; overflow-y: scroll;' : 'height: auto;'"
                                                        >
                                                            <li
                                                                class="media py-3"
                                                                v-for="(carte,i) in cards"
                                                                :key="i"
                                                                style="cursor: pointer;"
                                                                @click="payWithApaym(carte)"
                                                            >
                                                                <div class="mr-3 position-relative">
                                                                    <img
                                                                        class
                                                                        :src="require(`../assets/img/cards/${carte.imgCard}`)"
                                                                        alt="image"
                                                                        width="45"
                                                                    />
                                                                    <!-- <span
                                                                        :class="carte.statut_card == 1 ? 'badge-point badge-success avatar-badge' : 'badge-point badge-danger avatar-badge'"
                                                                        v-b-tooltip
                                                                        :title="carte.statut_card == 1 ? 'Carte active' : 'Carte inactive'"
                                                                    ></span> -->
                                                                </div>
                                                                <div class="media-body">
                                                                    <div
                                                                        class="d-flex justify-content-between"
                                                                        style="text-align: left;"
                                                                    >
                                                                        <div>
                                                                            {{ carte.nickname }}
                                                                            <br />
                                                                            <span class="font-11">
                                                                                Visa **** {{ carte.last_4_digit }}
                                                                                <img
                                                                                    src="../assets/img/icons/icon-recieve_money-193.png"
                                                                                    alt
                                                                                    width="15"
                                                                                    class="ml-2"
                                                                                    v-b-tooltip
                                                                                    title="Carte favorite"
                                                                                    :hidden="carte.favori_card == false"
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                        <div>Cliquez sur l'une de vos cartes pour effectuer le paiement</div>
                                                    </div>
                                                    <!-- Liste des cartes -->

                                                    <div class="mt-3">
                                                        <loading
                                                            :active.sync="isLoadingAPaymAuth"
                                                            :can-cancel="false"
                                                            :on-cancel="onCancelAPaymAuth"
                                                            :is-full-page="fullPageAPaymAuth"
                                                        ></loading>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </b-card-text>
                    </b-tab>

                </b-tabs>
                <!-- Small screen Only -->

            </form>
            <!-- Le Body -->
        </b-modal>
        <!-- Begin Payement Section -->


        <!-- Orange money modal -->
        <b-modal
            class="modal-content"
            id="openOrangeMoney"
            ref="openOrangeMoneyModal"
            no-close-on-backdrop
            hide-footer
            hide-header
            scrollable
            style="padding: 0;"
            size="lg"
        >
            <div
                class="btn btn-link btn-floating btn-sm btn-close-modal display-for-large-only"
                @click="closeModal('openOrangeMoneyModal')"
            >
                <i class="fas fa-times"></i>
            </div>
            <div
                class="btn btn-link btn-floating btn-sm btn-close-modal-small display-for-small-only"
                @click="closeModal('openOrangeMoneyModal')"
            >
                <i class="fas fa-times"></i>
            </div>
            <div class="modalOrangeMoney">
                <iframe
                    :src="urlOrange"
                    frameborder="0"
                    scrolling="yes"
                    style="height: inherit; width: 100%;"
                ></iframe>
            </div>
        </b-modal>
        <!-- Orange money modal -->

        <!-- BICICI modal -->
        <b-modal
            class="modal-content"
            id="openBicici"
            ref="openBiciciModal"
            no-close-on-backdrop
            hide-footer
            hide-header
            scrollable
            style="padding: 0;"
        >
            <div
                class="btn btn-link btn-floating btn-sm btn-close-modal display-for-large-only"
                @click="closeModal('openBiciciModal')"
            >
                <i class="fas fa-times"></i>
            </div>
            <div
                class="btn btn-link btn-floating btn-sm btn-close-modal-small display-for-small-only"
                @click="closeModal('openBiciciModal')"
            >
                <i class="fas fa-times"></i>
            </div>
            <div class="modalBiciciMoney">
                <iframe
                    :src="contentBicici"
                    frameborder="0"
                    scrolling="yes"
                    style="height: inherit; width: 100%;"
                ></iframe>
            </div>
        </b-modal>
        <!-- BICICI money modal -->

        <!-- *********** -->
        <!-- *********** -->
        <!-- MODAL BLOC -->
        <!-- *********** -->
        <!-- *********** -->

    </div>
</template>


<script src="https://js.pusher.com/7.0/pusher.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/vue/dist/vue.js"></script>
<script>

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import json from '../constants/flags.json';
    import { sweetAlert } from "../constants/functions";
    import axios from 'axios';
    import { apiUrl, _reference /*, _token, _numero , _rules, _change_pwd*/ } from '../constants/config';
    import { trim } from 'jquery';
    import Multiselect from "vue-multiselect";

    export default {
        components: {
            Loading,
            multiselect: Multiselect,
        },
        metaInfo()  {
            return {
                // if no subcomponents specify a metaInfo.title, this title will be used
                title: this.unSlugify(this.$route.params.slug),
                // all titles will be injected into this template
                titleTemplate: '%s | Paiement marchand'
            }
        },
        data() {
            return {
                showCard: false,
                cards: [],
                cardsLength: 0,
                loginApaym: true,
                hideCodePay: false,
                tabIndex: 0,
                mtnOkay: false,
                mtnNOkay: false,
                orangeOkay: false,
                orangeNOkay: false,
                moovOkay: false,
                moovNOkay: false,
                hide: true,
                isLoading: false,
                fullPage: true,
                isLoadingQr: false,
                fullPageQr: false,
                isLoadingMomo: false,
                fullPageMomo: false,
                isLoadingAPaym: false,
                fullPageAPaym: false,
                isLoadingAPaymAuth: false,
                fullPageAPaymAuth: false,
                isLoadingOrange: false,
                fullPageOrange: false,
                isLoadingFlooz: false,
                fullPageFlooz: false,
                isLoadingBicici: false,
                fullPageBicici: false,
                indice: "225",
                json: [],
                qrCodeUri: "",
                stopInterval: null,
                urlOrange: "",
                isBicici: false,
                isOtherCard: false,
                cardChoice: true,
                contentBicici: "",
                formBicici: false,
                cardType: "",
                dataFormulaire: {
                    nom: "",
                    prenom: "",
                    telephone: "",
                    email: "",
                    montant: "",
                    motif: "",
                    devise: "XOF"
                }, 
                dataApaymPay: {
                    indice: "225",
                    numApaym: "",
                    codeApaym: ""
                },
                dataApaymPayAuth: {
                    indice: "225",
                    numApaym: "",
                    codeApaym: "",
                    token: ""
                },
                dataVisaCard: {
                    pan : "",
                    expiration: "",
                    cvv: ""
                },
                dataMoMo: {
                    numero : ""
                },
                dataMoov: {
                    numero : ""
                },
                url_data: {
                    code_page: "",
                    slug: ""
                },
                dataPage: {
                    name_page: "",
                    description_page: "",
                    business_logo: "",
                    business_name: "",
                    business_vpan: "",
                    amount: "",
                    page_redirect: "",
                    email_notify: "",
                    success_message: "",
                    seo_image: "",
                    slug: ""
                },
                options: [],
                pageType: "page"
            }
        },
        computed: {
        },
        methods: {

            // Allows numbers only, amount field
            numbersOnly(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },

            // BICICI payment, select type of card (Visa or Mastercard)
            selectCardType(event){
                this.cardType = event.target.value ;
            },

            // Fermer un modal, en paramètre on a la référence du modal que l'on souhaite fermer
            closeModal(refModal) {
                this.$refs[refModal].hide() ;
            },

            onCancel() {
                console.log('Loader dismiss') ;
            },

            onCancelAPaym() {
                console.log('Loader APaym dismiss') ;
            },

            onCancelAPaymAuth() {
                console.log('Loader APaym Auth dismiss') ;
            },

            onCancelQr() {
                console.log('Loader QR Code dismiss') ;
            },

            onCancelMomo() {
                console.log('Loader MoMo dismiss') ;
            },

            onCancelOrange() {
                console.log('Loader Orange money dismiss') ;
            },

            onCancelFlooz() {
                console.log('Loader Flooz dismiss') ;
            },

            onCancelBicici() {
                console.log('Loader BICICI dismiss') ;
            },

            // Get information of payment page
            getInfosPage(code_page) {

                this.isLoading = true;
                let dataSend = new FormData();
                dataSend.append("code_page", code_page);

                axios.post(apiUrl + 'api/payment-merchant/page-infos',
                    dataSend
                ).then(response => {

                    this.isLoading = false;
                    console.log(response);

                    if (response.data.code !== 1) {
                        this.$router.push("/*");
                        return false;
                    }

                    if (response.data.slug !== this.url_data.slug) {
                        this.$router.push("/*");
                        return false;
                    }

                    this.dataPage.name_page = response.data.name_page;
                    this.dataPage.description_page = response.data.description_page;
                    this.dataPage.business_logo = response.data.MerchantLogo;
                    this.dataPage.business_name = response.data.MerchantBusinessName;
                    this.dataPage.business_vpan = response.data.vpan;
                    this.dataPage.amount = response.data.amount;
                    this.dataPage.page_redirect = response.data.page_redirect;
                    this.dataPage.email_notify = response.data.email_notify;
                    this.dataPage.success_message = response.data.success_message;
                    this.dataPage.seo_image = response.data.seo_image;
                    this.dataPage.slug = response.data.slug;
                    this.dataFormulaire.montant = response.data.amount;

                }).catch(error => {

                    this.isLoading = false;
                    console.log(error);
                    this.$swal(
                        'Un erreur est survenue !',
                        error.response.data,
                        'error'
                    );

                });
            },

            payer() {  

                if (
                    this.dataFormulaire.nom.replace(/\s/g, "") == "" ||
                    this.dataFormulaire.prenom.replace(/\s/g, "") == "" ||
                    this.dataFormulaire.telephone.replace(/\s/g, "") == "" ||
                    this.dataFormulaire.montant.replace(/\s/g, "") == ""
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner tous les champs non optionnels !');
                    return false;
                }

                if ( isNaN(this.dataFormulaire.montant) ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner un montant correct !');
                    return false;
                }

                // Set toutes la values à false
                this.qrCodeUri = "" ;
                this.orangeOkay = false ;
                this.orangeNOkay = false ;
                this.mtnOkay = false ;
                this.mtnNOkay = false ;
                this.moovNOkay = false ;
                this.moovOkay = false;

                // Init Payment process
                this.isLoading = true;
                let dataSend = new FormData();
                dataSend.append("code_page", this.url_data.code_page);
                dataSend.append("nom", trim(this.dataFormulaire.nom)); 
                dataSend.append("prenom", trim(this.dataFormulaire.prenom));
                dataSend.append("numero", this.indice.code +""+ this.dataFormulaire.telephone.replace(/\s/g, ""));
                dataSend.append("amount", this.dataFormulaire.montant); 
                dataSend.append("email", trim(this.dataFormulaire.email));
                dataSend.append("motif", trim(this.dataFormulaire.motif));

                axios.post(apiUrl + 'api/payment-merchant/init',
                    dataSend
                ).then(response => {

                    this.isLoading = false;

                    if ( response.data.code == 1 ) {

                        _reference.set(response.data["reference"]);
                        this.$refs['openPaymentModal'].show();

                        // Generate QR Code with reference
                        this.generateQr(_reference.get()) ;

                        // Set the phone number to APaym login
                        this.dataApaymPayAuth.numApaym =  this.dataFormulaire.telephone ;

                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                }).catch(error => {

                    this.isLoading = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                    
                });
                
            },

            generateQr(ref) {

                this.isLoadingQr = true ;
                let dataSend = new FormData();
                dataSend.append("reference", ref);

                axios.post(apiUrl + 'api/payment-merchant/generate-qr',
                    dataSend
                ).then(response => {

                    this.isLoadingQr = false;

                    if ( response.data.code == "success" ) {
                        this.qrCodeUri = response.data.qrCodeUri ;
                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                }).catch(error => {

                    this.isLoadingQr = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });
            },

            sendAPaym() {

                if (
                    this.dataApaymPay.numApaym.replace(/\s/g, "") == "" ||
                    this.dataApaymPay.codeApaym.replace(/\s/g, "") == ""  
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner numéro de téléphone APaym ainsi que votre code de paiement !');
                    return false;
                } 

                this.isLoadingAPaym = true;
                let dataSend = new FormData();
                dataSend.append("reference", _reference.get());
                dataSend.append("numAPaym", this.dataApaymPay.indice +""+ this.dataApaymPay.numApaym.replace(/\s/g, ""));
                dataSend.append("codePaiement", this.dataApaymPay.codeApaym.replace(/\s/g, ""));

                axios.post(apiUrl + 'api/payment-merchant/apaym',
                    dataSend
                ).then(response => {

                    this.isLoadingAPaym = false;

                    if ( response.data.code == 1 ) {
                        
                        this.hide = !this.hide ;
                        this.$refs['openPaymentModal'].hide();
                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                }).catch(error => {

                    this.isLoadingAPaym = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });
                
            },

            sendAPaymAuth() {

                if (
                    this.dataApaymPayAuth.numApaym.replace(/\s/g, "") == ""   
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner numéro de téléphone APaym ainsi que votre code de paiement !');
                    return false;
                } 

                this.isLoadingAPaymAuth = true;
                this.hideCodePay = false ;

                let dataSend = new FormData();
                dataSend.append("numero", this.dataApaymPayAuth.indice +""+ this.dataApaymPayAuth.numApaym.replace(/\s/g, ""));

                axios.post(apiUrl + 'api/payment-merchant/login-apaym',
                    dataSend
                ).then(response => {

                    this.isLoadingAPaymAuth = false;

                    if ( response.data.code == 1 ) {
                        
                        this.hideCodePay = true ;
                        this.dataApaymPayAuth.token = response.data.token ;
                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);

                }).catch(error => {

                    this.isLoadingAPaymAuth = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });
                
            },

            sendAPaymToken(){

                if (
                    this.dataApaymPayAuth.numApaym.replace(/\s/g, "") == "" ||
                    this.dataApaymPayAuth.codeApaym.replace(/\s/g, "") == ""  
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner numéro de téléphone APaym ainsi que votre code de connexion !');
                    return false;
                } 

                this.isLoadingAPaymAuth = true;
                let dataSend = new FormData();
                dataSend.append("numero", this.dataApaymPayAuth.indice +""+ this.dataApaymPayAuth.numApaym.replace(/\s/g, ""));
                dataSend.append("codeConnexion", this.dataApaymPayAuth.codeApaym.replace(/\s/g, ""));
                dataSend.append("token", this.dataApaymPayAuth.token);

                axios.post(apiUrl + 'api/payment-merchant/token-apaym',
                    dataSend
                ).then(response => {

                    this.isLoadingAPaymAuth = false;

                    if ( response.data.code == 1 ) {

                        // Mask APaym auth form
                        this.loginApaym = false ;
                        this.hideCodePay = false ;
                        
                        // Show list of cards
                        this.cards = [];
                        this.cardsLength = response.data["nombre_cards"];
                        this.showCard = true ;

                        for (let card of response.data["cards"]) {
                            
                            if (card.card_key_name == "NSIACIVISAPCN") {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'Carte-apaym-01.png'
                                    }
                                )
                                    
                            } else if (card.card_key_name == "UBACIVISAPPB") {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'Carte-apaym-06.png'
                                    }
                                )

                            } else if (card.card_key_name == "UBACIVISAPPN") {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'Carte-apaym-05.png'
                                    }
                                )

                            } else if (card.card_key_name == "UBACIVISAVCN") {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'Carte-Virtuelle-APAYM-UBA.png'
                                    }
                                )

                            } else {

                                this.cards.push(
                                    {
                                        id: card.id,
                                        bank: card.bank,
                                        card_color: `background-image: linear-gradient(to right bottom, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color}, ${card.card_color})`,
                                        last_4_digit: card.last_4_digit,
                                        nickname: card.nickname,
                                        favori_card: card.favori_card,
                                        favori_card_: card.favori_card ? 1 : 0,
                                        imgCard: 'visa-autre.png'
                                    }
                                )

                            }

                        }

                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);
                    
                    this.showCard = false ;
                    this.hideCodePay = false ;
                    this.loginApaym = true ;
                    this.dataApaymPayAuth.codeApaym = "" ;
                    this.dataApaymPayAuth.token = "" ;

                }).catch(error => {

                    this.isLoadingAPaymAuth = false;
                    this.showCard = false ;
                    this.hideCodePay = false ;
                    this.loginApaym = true ;
                    this.dataApaymPayAuth.codeApaym = "" ;
                    this.dataApaymPayAuth.token = "" ;

                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });

            },

            disconnectApaym() {

                this.showCard = false ;
                this.hideCodePay = false ;
                this.loginApaym = true ;

                this.dataApaymPayAuth.codeApaym = "" ;
                this.dataApaymPayAuth.token = "" ;
            },

            payWithApaym(carte) {

                this.$swal({
                    title: 'Paiement APaym',
                    text: "Votre carte "+ carte.nickname +" sera débitée de "+ this.dataFormulaire.montant +" "+ this.dataFormulaire.devise +" pour valider le paiement.",
                    icon: 'info',
                    showCancelButton: true,
                    // confirmButtonColor: '#21',
                    cancelButtonColor: '#6e7881',
                    confirmButtonText: 'Oui, je valide !',
                    cancelButtonText: 'Non',
                    reverseButtons: true
                }).then((result) => {

                    if (result.isConfirmed) {
                        
                        this.isLoadingAPaymAuth = true;
                        let dataSend = new FormData();
                        dataSend.append("numero", this.dataApaymPayAuth.indice +""+ this.dataApaymPayAuth.numApaym.replace(/\s/g, ""));
                        // dataSend.append("token", this.dataApaymPayAuth.token);
                        dataSend.append("code", this.dataApaymPayAuth.token);
                        dataSend.append("reference", _reference.get());
                        dataSend.append("card_id", carte.id);

                        axios.post(apiUrl + 'api/payment-merchant/pay-with-apaym',
                            dataSend
                        ).then(response => {

                            this.isLoadingAPaymAuth = false;
                            this.$swal.close() ;

                            if ( response.data.code == 1 ) {

                                this.hide = !this.hide ;
                                this.$refs['openPaymentModal'].hide();
                                return false;
                            }

                            sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);
                            this.showCard = false ;
                            this.hideCodePay = false ;
                            this.loginApaym = true ;

                            this.dataApaymPayAuth.codeApaym = "" ;
                            this.dataApaymPayAuth.token = "" ;

                        }).catch(error => {

                            this.isLoadingAPaymAuth = false;
                            console.log(error);
                            sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                            this.showCard = false ;
                            this.hideCodePay = false ;
                            this.loginApaym = true ;

                            this.dataApaymPayAuth.codeApaym = "" ;
                            this.dataApaymPayAuth.token = "" ;

                        });

                    }
                });
            },

            sendVisa() {

                if (
                    this.dataVisa.pan.replace(/\s/g, "") == "" ||
                    this.dataVisa.expiration.replace(/\s/g, "") == "" ||
                    this.dataVisa.cvv.replace(/\s/g, "") == "" 
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner les informations de votre carte Visa !');
                    return false;
                }
            },

            sendBicici() { 

                if ( this.cardType == "" ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Attention', "Veuillez préciser si votre carte est Visa ou Mastercard !");
                    return false ;
                }

                this.isLoadingBicici = true ;

                let dataSend = new FormData(); 
                dataSend.append("reference", _reference.get());
                dataSend.append("cardType", this.cardType);

                axios.post(apiUrl + 'api/payment-merchant/bicici',
                    dataSend
                ).then(response => {

                    this.isLoadingBicici = false ;

                    if ( response.data.code == 1 ) {

                        if ( response.data.status == "INITIALIZED" ) {

                            this.contentBicici = response.data.redirect_url ;
                            // this.$refs['openBiciciModal'].show();
                            this.isBicici = !this.isBicici ;
                            this.formBicici = !this.formBicici ;

                            return false;
                        }

                        sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                    return false;
                    
                }).catch(error => {

                    this.isLoadingBicici = false ;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });
                
            },

            sendOM() { 

                this.orangeOkay = false ;
                this.orangeNOkay = false ;

                this.isLoadingOrange = true ;
                let dataSend = new FormData();
                dataSend.append("reference", _reference.get());

                axios.post(apiUrl + 'api/payment-merchant/omoney',
                    dataSend
                ).then(response => {

                    // console.log(response);
                    if ( response.data.code == 1 ) {
                        
                        // setTimeout(()=>{
                        //     window.open( response.data.url, '_blank' );
                        //     //window.location.href = response.data.url ;
                        // }, 3000) ;

                        if ( response.data.url == null || response.data.url == "" ) {

                            this.isLoadingOrange = false ;
                            this.$refs['openOrangeMoneyModal'].hide();
                            sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Le service est temporairement indisponible, veuillez réessayer plus tard.");

                            return false ;
                        }

                        if ( this.isMobile() ) {

                            this.isLoadingOrange = false ;
                            this.orangeOkay = true ;

                            // Open iframe in Modal
                            // this.urlOrange = response.data.url ;
                            // this.$refs['openOrangeMoneyModal'].show();

                            // Open App Orange money if exist on device
                            window.location.href = response.data.url ;

                            return false ;
                        }

                        // Open iframe in Modal
                        this.isLoadingOrange = false ;
                        this.urlOrange = response.data.url ;
                        this.orangeOkay = true ;
                        this.$refs['openOrangeMoneyModal'].show();

                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);
                    this.isLoadingOrange = false ;

                }).catch(error => {

                    this.isLoadingOrange = false ;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });
            },

            sendMoMo() { 

                this.mtnOkay = false ;
                this.mtnNOkay = false ;

                if (
                    this.dataMoMo.numero.replace(/\s/g, "") == ""
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner votre numéro MoMo !');
                    return false;
                }

                this.isLoadingMomo = true ;
                let dataSend = new FormData();
                dataSend.append("reference", _reference.get());
                dataSend.append("numero", this.dataMoMo.numero.replace(/\s/g, ""));

                axios.post(apiUrl + 'api/payment-merchant/momo',
                    dataSend
                ).then(response => {

                    // console.log(response);

                    if ( response.data.code == 1000 ) {
                        
                        this.isLoadingMomo = true ;
                        this.mtnOkay = true ;
                        return false;

                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"]);
                    this.isLoadingMomo = false ;

                }).catch(error => {

                    this.isLoadingMomo = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });
            },

            sendMoov() { 

                this.moovOkay = false ;
                this.moovNOkay = false ;

                if (
                    this.dataMoov.numero.replace(/\s/g, "") == ""
                ) {
                    sweetAlert(this.$swal, true, 'top-end', 'info', 'Info', 'Veuillez renseigner votre numéro Flooz !');
                    return false;
                }

                this.isLoadingFlooz = true;

                let dataSend = new FormData();
                dataSend.append("reference", _reference.get());
                dataSend.append("numero", this.dataMoov.numero.replace(/\s/g, ""));

                axios.post('https://carte.abidjan.net/apaym_pro/api/payment-merchant/flooz',
                    dataSend
                ).then(response => {

                    if ( response.data.code == 1 ) {
                        
                        this.isLoadingFlooz = true ;
                        this.moovOkay = true ;

                        // Vérification du statut de la transaction Flooz
                        this.stopInterval = setInterval(() => {
                            this.checkingFloozStatus() ;
                        }, 40000);

                        return false;
                    }

                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', response.data["message"].split(":")[1]);
                    this.isLoadingFlooz = false ;

                }).catch(error => {

                    this.isLoadingFlooz = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");

                });
            },

            checkingFloozStatus() {

                let dataSend = new FormData();
                dataSend.append("reference", _reference.get());

                axios.post('https://carte.abidjan.net/apaym_pro/api/payment-merchant/verify-flooz-status',
                    dataSend
                ).then(response => {

                    // console.log(response) ;

                    // Transaction was successfully
                    if ( response.data.statusCode == 0 ) {

                        clearInterval(this.stopInterval);
                        this.isLoadingFlooz = false ;
                        this.hide = false ;
                        my.$refs['openPaymentModal'].hide();

                    } else if ( response.data.statusCode == 47 ) {
                        
                        // Transaction is still pending
                        return false ;

                    } else  {

                        // Transaction was failed
                        clearInterval(this.stopInterval);
                        this.isLoadingFlooz = false ;
                        this.moovNOkay = true ;
                        this.moovOkay = false;
                    }

                }).catch(error => {

                    this.isLoadingFlooz = false;
                    console.log(error);
                    sweetAlert(this.$swal, true, 'top-end', 'error', 'Erreur', "Une erreur est survenue, veuillez réessayer plus tard");
                });
            },

            unSlugify(slug) {
                const result = slug.replace(/\-/g, " ");
                return result.replace(/\w\S*/g, function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                });
            },

            isMobile() {
                var check = false;
                (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
                return check;
            }
            
        },
        mounted() {

            this.json = [...json];

            for ( let j of json ) {
                this.options.push(
                    {
                        country_code: j.flag +" +"+j.dial_code,
                        country: j.flag +" "+ j.name +" +"+ j.dial_code ,
                        code: j.dial_code
                    }
                )
            }

            this.indice = this.options.find(option => option.code === "225");

            this.url_data.code_page = this.$route.params.code_page;
            this.url_data.slug = this.$route.params.slug;

            if (!this.url_data.code_page || !this.url_data.slug) {
                this.$router.push("/*");
            }

            this.getInfosPage(this.url_data.code_page);
            //document.title = this.unSlugify(this.$route.params.slug); 

            // Update screen page with pusher 
            Pusher.logToConsole = false;
            var channel = this.$pusher.subscribe('wby-channel');
            var my = this ;
            var response = function(data) {

                if ( data.type == "QR" ) {

                    if ( data.status == "success" && data.reference == _reference.get() ) {
                        my.hide = !my.hide ;
                        my.$refs['openPaymentModal'].hide();
                        return false;
                    }      

                } else if ( data.type == "MTN Money" ) {

                    if ( data.status == "success" && data.reference == _reference.get() ) {

                        my.hide = !my.hide ;
                        my.$refs['openPaymentModal'].hide();

                    } else if ( (data.responseCode == "529" || data.responseCode == "515" || data.responseCode == "9" || data.responseCode == "100")  && data.reference == _reference.get() ) {

                        my.isLoadingMomo = false ;
                        my.mtnNOkay = true ;
                        my.mtnOkay = false;
                    }

                } else if ( data.type == "Orange Money" ) {

                    if ( data.status == "success" && data.reference == _reference.get() ) {

                        my.hide = false ;
                        my.$refs['openPaymentModal'].hide();
                        my.$refs['openOrangeMoneyModal'].hide();

                    } else if ( data.responseCode !== "SUCCESS" && data.reference == _reference.get() ) {

                        my.isLoadingOrange = false ;
                        my.orangeNOkay = true ;
                        my.orangeOkay = false;
                        my.$refs['openOrangeMoneyModal'].hide();

                    }

                }  else if ( data.type == "BICICI" ) {

                    if ( data.status == "success" && data.reference == _reference.get() ) {

                        my.hide = false ;
                        my.$refs['openPaymentModal'].hide();
                        my.$refs['openBiciciModal'].hide();

                    } else if ( data.responseCode !== "BICICI-SUCCESS" && data.reference == _reference.get() ) {

                        my.formBicici = false ;
                        my.isBicici = true ;
                        my.$refs['openBiciciModal'].hide();
                    }
                }
            };

            // Écouteur sur les mises à jour des paiements pour checker le statut
            channel.bind('payment-merchant', response);

        },
        watch: {}
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .btn-close-modal {
        position: absolute;
        font-size: 15px;
        color: rgb(255, 255, 255);
        top: -4px;
        cursor: pointer;
        font-weight: 700;
        left: 102%;
        background: rgb(0 0 0 / 10%);
        height: 25px;
        width: 25px;
    }

    .btn-close-modal-small {
        position: absolute;
        color: rgb(255, 255, 255);
        top: 0px;
        cursor: pointer;
        font-weight: 700;
        /* left: 90%; */
        right: 0;
        background: #1b1e21;
        height: 25px;
        width: 25px;
    }

    .text-modal-small {
        position: absolute;
        color: #1b1e21;
        top: 0px;
        font-weight: 700;
        font-size: 16px;
        /* left: 40%; */
        left: 0;
        white-space: break-spaces;
    }

    .btn-close-modal:hover {
        background: rgb(255, 159, 0);
    }

    .btn-disabled-custom {
        border-radius: 8px;
        background: rgb(0 0 0 / 8%);
        border: rgb(0 0 0 / 8%);
        /* color: #a1a5a9; */
        color: #1b1e21;
    }

    .searchIcon {
        margin-left: -25px;
        cursor: pointer;
        color: #261b64;
        cursor: pointer;
        font-size: 17px;
    }

    .payment__type {
        /* padding: 25px 0px; */
        cursor: pointer;
        transition: all 0.15s ease;
        margin-right: 0px;
        /*width: max-content;*/
        white-space: nowrap;
    }

</style>
